import { VisaDocumentHotelsModel } from 'api-hooks/visa-document';
import EmptyView from 'components/common/empty-view';
import { Input } from 'components/elements';
import HotelSelectInput from 'legacy-modules/master/hotel/components/select-input';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import VisaHotelTable from './visa-hotel-table';

const parentName = 'visaDocumentHotels' as const;

export default function VisaDocumentHotelForm({
  visaDocumentHotels,
}: {
  visaDocumentHotels?: VisaDocumentHotelsModel[];
}) {
  const { t } = useTranslation();

  const name = `${parentName}.0` as const;

  if (visaDocumentHotels?.length === 0) {
    return <EmptyView />;
  }

  return (
    <FullContainer
      style={{
        overflow: 'auto',
        maxHeight: 'calc(100dvh - 250px)',
      }}
    >
      <SectionContainer>
        <HalfContainer>
          <HotelSelectInput
            name={`${name}.hotelId`}
            label={t('common:hotel')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name={`${name}.remark`}
            label={t('common:remarks')}
          />
        </HalfContainer>
      </SectionContainer>
      <SeparatorVertical $margin={24} />
      <VisaHotelTable parentIndex={0} />
    </FullContainer>
  );
}
